import LoginFormView from './views/login/loginFormView.js';
import ResetPasswordFormView from './views/login/resetPasswordFormView.js';
import TrialSignupFormView from './views/login/TrialSignupFormView.js';

// This router is seperate as it will never run parallel to the appRouter
const LoginRouter = Backbone.Router.extend({
  options: {},
  storedUrlHash: null,
  loginForm: null,
  resetForm: null,

  routes: {
    login: 'defaultLogin',
    'login/passwordReset': 'loginPasswordReset',
    'login/redirect/:url/:appId': 'loginRedirect',
    signout: 'loggedOutLogin',
    signup: 'handleSignup',
    forgotmypassword: 'forgotPassword',
    'forgotmypassword/reset/:code/': 'resetPassword',
    'forgotmypassword/reset/:code': 'resetPassword',
    'auth/error/:token': 'loginError',
    '*splat': 'storeHashFragment',
  },

  initialize(options) {
    _.extend(this, options);

    Utils.addStrongPasswordJqueryValidation();

    this.loginFormOptions = _.extend(this.options, {
      app_router: this,
    });
  },

  cleanup(CurrentViewClass) {
    if (this.activeView && !(this.activeView instanceof CurrentViewClass)) {
      this.activeView.cleanup();
      delete this.activeView;
    }
  },

  defaultLogin() {
    if (this.storedUrlHash != null) this.options.storedUrlHash = this.storedUrlHash;

    // if loadLnguage is not empty then load the language before displaying
    if (this.loadLanguage !== '') {
      loginContext.loadLanguage(_.bind(this.defaultLogin, this), this.loadLanguage);
      this.loadLanguage = '';
      return;
    }

    // load login form
    this.cleanup(LoginFormView);
    this.activeView = new LoginFormView(this.loginFormOptions);
  },

  loginRedirect(url, appId) {
    if (this.storedUrlHash != null) this.options.storedUrlHash = this.storedUrlHash;

    // load login form
    this.cleanup(LoginFormView);

    this.options = _.extend({
      redirectURL: url,
      applicationId: appId,
    }, this.options);

    this.activeView = new LoginFormView(this.options);
  },

  loginPasswordReset() {
    const options = $.extend(true, {}, this.loginFormOptions);

    if (this.storedUrlHash != null) this.options.storedUrlHash = this.storedUrlHash;

    options.message = {
      message: {
        type: 'info',
        value: window.lookup('Your password has been reset'),
      },
    };

    // load login form
    this.cleanup(LoginFormView);
    this.activeView = new LoginFormView(options);
  },

  loggedOutLogin() {
    const options = $.extend(true, {}, this.loginFormOptions);

    // if loadLnguage is not empty then load the language before displaying
    if (this.loadLanguage !== '') {
      loginContext.loadLanguage(_.bind(this.loggedOutLogin, this), this.loadLanguage);
      this.loadLanguage = '';
      return;
    }

    this.cleanup(LoginFormView);
    this.activeView = new LoginFormView(options);
  },

  handleSignup() {
    // check if they are allowed to navigate to signup first
    if (!window.appConfig.signup_key) {
      // if not redirect back to login page
      this.navigate('login', { trigger: true, replace: true });

      return;
    }
    // if loadLnguage is not empty then load the language before displaying
    if (this.loadLanguage !== '') {
      loginContext.loadLanguage(_.bind(this.handleSignup, this), this.loadLanguage);
      this.loadLanguage = '';
      return;
    }

    if (this.signupView) {
      this.signupView.cleanup();
    }

    this.cleanup(TrialSignupFormView);

    this.signupView = new TrialSignupFormView({ parent: this });
  },

  loginError(message) {
    const options = $.extend(true, {}, this.loginFormOptions);

    options.message = { message: { type: 'error', value: message } };

    this.cleanup(LoginFormView);
    this.activeView = new LoginFormView(options);
  },

  forgotPassword() {
    this.cleanup(ResetPasswordFormView);

    this.activeView = this.activeView || new ResetPasswordFormView({ parent: this });
    this.activeView.render({ mode: 'enterEmail' });
  },

  resetPassword(code) {
    this.cleanup(ResetPasswordFormView);

    this.activeView = this.activeView || new ResetPasswordFormView({ parent: this });

    if (code) {
      this.activeView.setCode(code);
    }

    this.activeView.render({ mode: 'resetPassword' });
  },

  storeHashFragment() {
    const hash = Backbone.history.getHash();

    if (hash != ''
        && hash != 'login'
        && hash != 'loginAsOther'
        && hash.indexOf('logout') === -1
        && hash.indexOf('logoutUserAndResetCache') === -1
        && hash.indexOf('signout') === -1
    ) {
      advancedLocalStorage.setItem('s_initialFragment', `#${Backbone.history.getHash()}`, 1);
    } else if (window.location.pathname !== '') {
      advancedLocalStorage.setItem('s_initialFragment', window.location.pathname, 1);
    }

    this.navigate('login', { trigger: true, replace: true });

    if (!this.isConcise) {
      window.location.pathname = '';
    }
  },

});

export default LoginRouter;
